export default {
  methods: {
    async validateOfferBeforeMove () {
      // Simple validation - just show the completion modal
      this.showSimpleOfferCompletionModal()
    },

    calculateTimeWindow () {
      const elapsedSeconds = this.timerSeconds || 0
      const cutoffTime = new Date(Date.now() - elapsedSeconds * 1000).toISOString()

      return {
        elapsedSeconds,
        cutoffTime
      }
    },

    async checkPhoneCallOrReport (applicantId, owner, cutoffTime) {
      try {
        const phoneStatsResponse = await this.$network_utils.getStats({
          resource_type: 'Applicant',
          resource_id: applicantId,
          owner: owner,
          date_from: cutoffTime
        })

        const phoneStats = Array.isArray(phoneStatsResponse)
          ? phoneStatsResponse
          : (phoneStatsResponse && phoneStatsResponse.data ? phoneStatsResponse.data : [])

        const hasPhoneCallOrReport = phoneStats.some(stat => {
          const designator = stat.designator || ''
          const isMatch = designator === 'applicant_answered_phone' ||
                         designator === 'applicant_did_not_answer_phone' ||
                         designator === 'massage_complete'

          if (isMatch) {
            console.log('[Validation] Found phone call/report stat:', stat)
          }
          return isMatch
        })

        return hasPhoneCallOrReport
      } catch (error) {
        throw error
      }
    },

    async checkOfferStatusOrMessageChange (offerId, owner, cutoffTime) {
      try {
        const offerStatsResponse = await this.$network_utils.getStats({
          resource_type: 'Offer',
          resource_id: offerId,
          owner: owner,
          date_from: cutoffTime
        })

        const offerStats = Array.isArray(offerStatsResponse)
          ? offerStatsResponse
          : (offerStatsResponse && offerStatsResponse.data ? offerStatsResponse.data : [])

        console.log(`[Validation] Offer stats found in time window:`, offerStats.length)

        const hasStatusOrMessageChange = offerStats.some(stat => {
          const designator = stat.designator || ''

          const isStatusChange = designator.startsWith('offer_to_')
          const isMessageChange = designator === 'next_contact_message_changed'
          const isMatch = isStatusChange || isMessageChange

          if (isMatch) {
            console.log('[Validation] Found status/message change:', stat)
          }
          return isMatch
        })

        return hasStatusOrMessageChange
      } catch (error) {
        console.error('[Validation] Error checking status/message change:', error)
        throw error
      }
    },

    openOfferStatusModalWithValidation (withDefaultMessage = false) {
      const offer = this.currentOffer || this.offer
      const applicant = (offer && offer.applicant) || this.applicant

      if (!offer) {
        console.error('[Validation] Cannot open modal - no offer data')
        return
      }

      const currentDate = new Date().toLocaleDateString('he-IL')
      const defaultMessage = withDefaultMessage
        ? `[${currentDate}] לא בוצעה שיחת טלפון אינפורמטיבית כיון - `
        : ''

      const applicantId = applicant ? (applicant.resource_id || applicant.id) : null

      const modalPayload = {
        designator: 'offer-status-form-modal',
        component_name: 'OfferStatusForm',
        modal_width: 1200,
        is_center_modal: true,
        offer_data: offer,
        defaultMessage: defaultMessage,
        shouldCreateMassageCompleteStat: withDefaultMessage,
        applicantId: applicantId,
        modal_title: `עדכון סטטוס הצעה #${offer.id}`,
        on_close: () => {
          console.log('OfferStatusForm modal closed')
          setTimeout(() => {
            this.proceedToNextOffer()
          }, 100)
        }
      }

      this.$store.commit('modals/create', modalPayload)
    },

    showSimpleOfferCompletionModal () {
      const alert = this.alert

      if (!alert || !alert.id) {
        this.proceedToNextOffer()
        return
      }

      this.$store.commit('modals/create', {
        designator: 'offer-completion-modal',
        component_name: 'ModalOfferHandlingOptions',
        modal_width: 450,
        is_center_modal: true,
        modal_title: 'סיום טיפול בהצעה',
        props: {
          message: 'האם הסתיים הטיפול בהצעה זו?',
          buttonStatusText: 'הסתיים לצמיתות. האופר לא יוצג בעתיד',
          buttonTimingText: 'צריך עוד מעקב בעתיד',
          onStatusChange: async () => {
            try {
              await this.$network_utils.updateAlert({
                id: alert.id,
                status: 'done'
              })

              this.$utils.emit('show_toast', {
                text: 'ההצעה סומנה כהסתיימה',
                type: 'success'
              })

              await this.proceedToNextOffer()
            } catch (error) {
              console.error('[Validation] Error marking alert as done:', error)
              this.$utils.emit('show_toast', {
                text: 'שגיאה בעדכון סטטוס ההתראה',
                type: 'error'
              })
            }
          },
          onTimingChange: () => {
            this.openTimingModalForFollowUp(alert)
          }
        }
      })
    },

    openTimingModalForFollowUp (alert) {
      if (!alert || !alert.id) {
        console.error('[Validation] Cannot open timing modal - no alert data')
        this.$utils.emit('show_toast', {
          text: 'חסרים נתוני משימה',
          type: 'error'
        })
        return
      }

      this.$store.commit('modals/create', {
        designator: 'follow-up-timing-modal',
        component_name: 'FeedAlertEditTiming',
        modal_title: 'בחירת מועד למעקב',
        is_center_modal: true,
        props: {
          alert: { id: alert.id },
          isSnoozeAll: false,
          onSubmit: async (modalId) => {
            this.$utils.emit('show_toast', {
              text: 'מועד המעקב עודכן בהצלחה',
              type: 'success'
            })

            this.$store.commit('modals/removeModalById', modalId)

            await this.proceedToNextOffer()
          }
        }
      })
    },

    openOfferStatusModalForAwaitingCompany () {
      const offer = this.currentOffer || this.offer
      const applicant = (offer && offer.applicant) || this.applicant

      if (!offer) {
        console.error('[Validation] Cannot open modal - no offer data')
        return
      }

      const applicantId = applicant ? (applicant.resource_id || applicant.id) : null

      const modalPayload = {
        designator: 'offer-status-form-modal',
        component_name: 'OfferStatusForm',
        modal_width: 1200,
        is_center_modal: true,
        offer_data: offer,
        defaultMessage: '',
        shouldCreateMassageCompleteStat: false,
        applicantId: applicantId,
        modal_title: `עדכון סטטוס הצעה #${offer.id}`,
        on_close: () => {
          console.log('OfferStatusForm modal closed after awaiting_company validation')
        }
      }

      this.$store.commit('modals/create', modalPayload)
    },

    openTimingModalForOffer (alert) {
      if (!alert || !alert.id) {
        console.error('[Validation] Cannot open timing modal - no alert data')
        this.$utils.emit('show_toast', {
          text: 'חסרים נתוני משימה',
          type: 'error'
        })
        return
      }

      this.$store.commit('modals/create', {
        designator: 'alerts-timing-modal',
        component_name: 'FeedAlertEditTiming',
        modal_title: 'שינוי מועד טיפול בהצעה',
        props: {
          alert: { id: alert.id },
          isSnoozeAll: true,
          onSubmit: (modalId) => {
            console.log('Timing modal submitted')
            this.$store.commit('modals/removeModalById', modalId)
          }
        }
      })
    },

    openPhoneCallConfirmationModal () {
      const offer = this.currentOffer || this.offer
      const applicant = (offer && offer.applicant) || this.applicant

      if (!offer || !applicant) {
        console.error('[Validation] Cannot open phone call confirmation modal - missing data')
        this.$utils.emit('show_toast', {
          text: 'חסרים נתוני הצעה/מועמד',
          type: 'error'
        })
        return
      }

      const applicantId = applicant.resource_id || applicant.id

      this.$store.commit('modals/create', {
        designator: 'phone-call-confirmation-modal',
        component_name: 'PhoneCallConfirmationModal',
        modal_width: 600,
        is_center_modal: true,
        modal_title: 'אישור שיחת טלפון',
        props: {
          applicantId: applicantId,
          onYes: () => {
            this.$store.commit('modals/removeModalByDesignator', 'phone-call-confirmation-modal')
            this.openOfferStatusModalWithValidation(false)
          },
          onNo: () => {
            this.$store.commit('modals/removeModalByDesignator', 'phone-call-confirmation-modal')

            this.openOfferStatusModalWithValidation(true)
          }
        }
      })
    },

    openPhoneCallConfirmationModalForApplicant () {
      const applicant = this.applicant

      if (!applicant) {
        console.error('[Validation] Cannot open phone call confirmation modal - missing data')
        this.$utils.emit('show_toast', {
          text: 'חסרים נתוני מועמד',
          type: 'error'
        })
        return
      }

      const applicantId = applicant.resource_id || applicant.id

      this.$store.commit('modals/create', {
        designator: 'phone-call-confirmation-modal-applicant',
        component_name: 'PhoneCallConfirmationModal',
        modal_width: 600,
        is_center_modal: true,
        modal_title: 'אישור שיחת טלפון',
        props: {
          applicantId: applicantId,
          onYes: () => {
            this.$store.commit('modals/removeModalByDesignator', 'phone-call-confirmation-modal-applicant')
            this.proceedToNextOffer()
          },
          onNo: () => {
            this.$store.commit('modals/removeModalByDesignator', 'phone-call-confirmation-modal-applicant')
            this.proceedToNextOffer()
          }
        }
      })
    },

    async proceedToNextOffer () {
      console.warn('[Validation] proceedToNextOffer not implemented in component')
    }
  }
}
